<div class="h-full" (contextmenu)="onContextMenu($event)">

  @if (panelModeLoaded()) {
    @if (panelMode()) {
      <app-workspace-panel
        [workspace]="workspace"
        [userRoles]="userRoles()"
        [currentStringName]="currentStringName()"
        [holeSectionName]="holeSectionName()"
        [componentInstance]="componentInstance()"
        [panelColumnCount]="panelColumnCount()"
        [panelRowSizes]="panelRowSizes()"
        [panelColSizes]="panelColSizes()"
        [initialWizardMode]="panelWizardMode()"
        [initialWizardStepIndex]="panelWizardStepIndex()"
        [stringDependentComponents]="stringDependentComponents"
        (componentRemoved)="removeUiComponent($event)"
        (rowResizeEnd)="onPanelRowResizeEnd($event)"
        (colResizeEnd)="onPanelColResizeEnd($event)">
      </app-workspace-panel>
    } @else {
      <app-workspace-gridstack
        [workspace]="workspace"
        [userRoles]="userRoles()"
        [currentStringName]="currentStringName()"
        [holeSectionName]="holeSectionName()"
        [componentInstance]="componentInstance()"
        [compactMode]="compactMode()"
        [compactRequestVersion]="compactRequestVersion()"
        [gridOptions]="gridOptions"
        [stringDependentComponents]="stringDependentComponents"
        [scrollToItemId]="scrollToItemId"
        (componentRemoved)="removeUiComponent($event)"
        (gridChanged)="onGridChanged($event)"
        (gridItemResized)="onGridItemResized($event)"
        (gridItemAdded)="onGridItemAdded($event)">
      </app-workspace-gridstack>
    }
  }

  <p-contextMenu #workspaceCm [model]="contextMenuItems()" appendTo="body"></p-contextMenu>
</div>
